import KVMViewer from "modus/components/misc/KVMViewer"
import React from "react"
import { ScopeData } from "../pages/application-summary-page/ResourceServerConfig"
import { Box, Checkbox, IconButton, Tooltip, makeStyles } from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";
import {useParams} from "react-router";
import {useAuthorization} from "../../authorizer/components/AuthorizationProvider";

const useStyles = makeStyles(() => ({
  controlsBox: {
    padding: '14px'
  },
  checkbox: {
    padding: '2px'
  }
}));

const titleStyle = {
  fontWeight: 500,
  fontSize: '14px'
}
interface ScopesListProps {
    data: ScopeData[],
    application_name: string,
    onEdit?: (scope: ScopeData) => void,
}
export const ScopesList:React.FC<ScopesListProps> = (props) => {
      const classes = useStyles();
      
      const handleEdit = (scope: ScopeData) => {
        if (props.onEdit) {
          props.onEdit(scope);
        }
      };

    const { id } = useParams<{ id: string }>();
    const { isActionAllowed } = useAuthorization("APPLICATION" , id);
    const canUpdate = isActionAllowed("update");


    return (
        <Box>
          {props.data.map((scope) => (
            <Box mb={4} key={scope.scope}>
              <KVMViewer
                titleStyles={titleStyle}
                controls={
                  <Box className={classes.controlsBox}>
                    <Tooltip title="Edit Scope">
                      <IconButton
                    size="small" 
                    color="primary" 
                    onClick={() => handleEdit(scope)}
                    disabled={!canUpdate}
                  >
                    <EditIcon fontSize="small" />
                  </IconButton>
                </Tooltip>
              </Box>}
                dataList={{
                [`Scope Name`] : scope.scope,
                ['User Consent Message'] : scope?.consentMessage?.trim() || 'Not Available',
                ['Developer Documentation'] : scope?.developerDocumentation?.trim() || 'Not Available',
                ['Always Show Consent '] : <Checkbox
                  checked={scope.alwaysShowConsent}
                  disabled={true}
                  color="primary"
                  size="small"
                  className={classes.checkbox} />
              }} />
           </Box>
          ))}
        </Box>
      );

}